function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    newOnTop,
    position
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var _theme$elevation;
    return _objectSpread({
      bottom: position === 'bottom' ? 0 : undefined,
      display: 'flex',
      flexDirection: newOnTop ? 'column-reverse' : 'column',
      maxHeight: '100%',
      position: 'fixed',
      right: 20,
      top: position === 'top' ? 20 : undefined,
      width: '87%',
      maxWidth: 360,
      zIndex: (_theme$elevation = theme.elevation) === null || _theme$elevation === void 0 ? void 0 : _theme$elevation.toast
    }, highContrastMediaQuery(theme));
  }, [newOnTop, position, theme]);
};
export default useStyles;